import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { SafeUrl, DomSanitizer } from "@angular/platform-browser";
import { formatDate } from '@angular/common';

import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { ServicingService } from '../../../../services/servicing.service';
import { CustomersService } from '../../../../services/customers.service';
import { ConfirmationDialogService } from '../../../general/modals/confirmation/confirmation.service';

import { GeneralService } from '../../../../services/general.service';

//import components
// import { ServicingCreateComponent } from '../../servicing-create/servicing-create.component';

// import { ServicingMaintenance } from '../../servicing-maintenance/servicing-maintenance.component';

// //import { ServicingCalendarComponent } from '../servicing-calendar/servicing-calendar.component';
// import { ServicingExtraOrdinaryComponent } from '../../servicing-list/servicing-extraordinary/servicing-extraordinary.component';
// import { ServicingOrdinaryComponent } from '../../servicing-list/servicing-ordinary/servicing-ordinary.component';
// import { ServicingViewserviceComponent } from '../../servicing-list/servicing-viewservice/servicing-viewservice.component';
// import { ServicingDocumentsComponent } from '../../servicing-list/servicing-documents/servicing-documents.component';


// import { CustomersOperatingComponent } from '../../customers_list/customers-operating/customers-operating.component';

// import { CustomersEmployeeComponent } from '../../customers_list/customers-employee/customers-employee.component';
// import { CustomersEmployeeComponent } from '../../customers_list/customers-employee/customers-employee.component';
import { ProtocolCreateComponent } from '../../project/project_view/protocol_create/protocol_create.component';
import { ProtocolViewComponent } from '../../project/project_view/protocol_view/protocol_view.component';
import { QualifiedTeacherService } from '../../../../services/qualified_teacher.service';
import { ProjectService } from '../../../../services/project.service';



//import multiselectdropdown
import { IDropdownSettings } from 'ng-multiselect-dropdown';

// import * as html2canvas from 'html2canvas';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';


declare var $: any;

@Component({
  selector: 'app-project-view',
  templateUrl: './project_view.component.html',
  styleUrls: ['./project_view.component.css']
})

export class ProjectViewComponent implements OnDestroy, OnInit {
  getPhotoBase64;

  dropdownList = [];
  dropdownList1 = [];
  dropdownList2 = [];
  dropdownList3 = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  //dropdownSettings:IDropdownSettings;

  //common data
  data: any;
  file: any;
  ollang: any;
  emplang: any;
  image: any;

  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableOptions2: any;
  datatableOptions3: any;
  datatableOptions4: any;
  datatableOptions5: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableColsDefs2: any;
  datatableColsDefs3: any;
  datatableColsDefs4: any;
  datatableColsDefs5: any;
  datatableCols1: any;
  datatableCols2: any;
  datatableCols3: any;
  datatableCols4: any;
  datatableCols5: any;
  datatableAddCols1: any;

  @Input() filter1: string;
  @Input() filter2: string;
  @Input() filter3: string;
  @Input() filter4: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addServicingModal: BsModalRef;
  viewServicingModal: BsModalRef;
  addExtraModel: BsModalRef;
  addMaintenanceModel: BsModalRef;
  deleteOption: any;
  extraordinayModal: BsModalRef;
  ordinayModal: BsModalRef;
  protocolModal:BsModalRef;
  operatingModal: BsModalRef;
  employeeModal: BsModalRef;
  ordinary_data: BsModalRef;

  lang: any;
  odlang: any;
  exodlang: any;
  generalData: any;
  mLang: any;
  maintenanceData: any;
  records: any;
  single_data: any;
  skills_data: any;
  skills_data1: any;
  tab_details2: any;

  optloc_data: any;
  get_project: any;
  scheduled_info: any;
  constant_data: any;
  get_employee: any;
  dynamic: any;
  plans: any;
  imgQR: any;
  exordinary_data: any;
  documents_data: any;
  planvals: any;
  cnt: any;
  doclang: any;
  protocol: any;
  course: any;
  plang: any;
  alang: any;
  clang: any;

  pageView: string = 'list';
  timezone = localStorage.getItem('timezone');

  id: number;

  
  generalsForm: FormGroup;
  generalsFormSubmitted: Boolean = false;
  generalsFormMsg: any;
  rolepermission: any;
  generalTab: any;
  selectedTab: any;

  constructor(
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private servicingService: ServicingService,
    private customersService: CustomersService,
    private modalService: BsModalService,
    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService,
    private ngxRolesService: NgxRolesService,
    private qualifiedTeacherService: QualifiedTeacherService,
    private projectService: ProjectService,
    
  ) { }

  image1: any | SafeUrl =
    "https://images.unsplash.com/photo-1521911528923-9c3838123490?ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80";

  updateImage(ev) {
    this.image1 = this.sanitizer.bypassSecurityTrustUrl(
      window.URL.createObjectURL(ev.target.files[0])
    );
  }

  public data1: Object[];
  public taskfield: Object; 

  ngOnInit() {
    //fetch data

    this.data = this.route.snapshot.data['sdata'];
    // console.log(this.data);  

    var role = this.ngxRolesService.getRole('clients');

    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }

    this.selectedTab = localStorage.getItem('selectedVal');

    if (this.selectedTab != "") {
      this.selectedTab = this.selectedTab;
    }
    else {
      this.selectedTab = 'general';
    }


    // this.getData();
    this.tab5Actions();
    //tab2 actions
    this.tab1Actions();
    // this.tab2Actions();
    this.tab3Actions();
    // this.tab4Actions();
    // this.tab5Actions();
    // this.tab6Actions();


    this.data1 = [{
      TaskID: 1,
      TaskName: 'Product Concept',
      StartDate: new Date('04/02/2019'),
      EndDate: new Date('04/21/2019'),
      subtasks: [{
          TaskID: 2,
          TaskName: 'Defining the product and its usage',
          StartDate: new Date('04/02/2019'),
          Duration: 5,
          Progress: 30
      },

      ]
  }, ];
  this.taskfield = {
      id: 'TaskID',
      name: 'TaskName',
      startDate: 'StartDate',
      endDate: 'EndDate',
      child: 'subtasks'
  };
    

  }


  onItemSelect(item: any) {
    console.log(item.item_id);
  }
  onSelectAll(items: any) {
    console.log(items);
  }


  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  pdfDownload() {
    var node = document.getElementById('QR_div');

    htmlToImage.toJpeg(node)
      .then(function (dataUrl) {
        // console.log(dataUrl); return false;
        var img = new Image();
        img.src = dataUrl;
        // document.body.appendChild(img);
        document.getElementById("imgQRD").click();
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });

  }

  datatableConfig1(): void {

    this.datatableColumns1();

    this.datatableOptions1 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs1,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');

        table1
          .on('select deselect', function (e, dt, type, indexes) {

            var table1 = new $.fn.dataTable.Api('#table1');
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons1 = new $.fn.dataTable.Buttons(table1, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod_DEMO_operating_location" + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'pdfHtml5',
              text: 'Export PDF',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCluod_DEMO_operating_location" + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod_DEMO_operating_location" + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod_DEMO_operating_location" + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn1'));

      }
    }


    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableConfig2(): void {

    this.datatableColumns2();

    this.datatableOptions2 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs2,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table2 = new $.fn.dataTable.Api('#table2');

          var count = table2.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table2.rows().deselect();
            selected = false;
          }
          else
            table2.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table2 = new $.fn.dataTable.Api('#table2');

        table2
          .on('select deselect', function (e, dt, type, indexes) {

            var table2 = new $.fn.dataTable.Api('#table2');
            var selected = table2.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table2, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.emplang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: this.emplang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: this.emplang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: this.emplang.print,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn2'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableConfig3(): void {

    this.datatableColumns3();

    this.datatableOptions3 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs3,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table3 = new $.fn.dataTable.Api('#table3');

          var count = table3.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table3.rows().deselect();
            selected = false;
          }
          else
            table3.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table3 = new $.fn.dataTable.Api('#table3');

        table3
          .on('select deselect', function (e, dt, type, indexes) {

            var table3 = new $.fn.dataTable.Api('#table3');
            var selected = table3.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table3, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.clang.exportCSV,
              className: 'btn btn-info',
              exportOptions: {
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table3');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: this.clang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table3');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: this.clang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table3');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: this.clang.print,
              className: 'btn btn-info',
              exportOptions: {
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table3');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  // return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn3'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }

  datatableConfig4(): void {

    this.datatableColumns4();

    this.datatableOptions4 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs4,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table4 = new $.fn.dataTable.Api('#table4');

          var count = table4.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table4.rows().deselect();
            selected = false;
          }
          else
          table4.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table4 = new $.fn.dataTable.Api('#table4');

        table4
          .on('select deselect', function (e, dt, type, indexes) {

            var table4 = new $.fn.dataTable.Api('#table4');
            var selected = table4.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons1 = new $.fn.dataTable.Buttons(table4, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: 'Export PDF',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn4'));

      }
    }


    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  // datatableConfig5(): void {

  //   this.datatableColumns5();

  //   this.datatableOptions5 = {
  //     paging: false,
  //     bAutoWidth: false,
  //     bSortClasses: false,
  //     columnDefs: this.datatableColsDefs5,
  //     select: {
  //       style: 'multi',
  //       selector: 'td:first-child'
  //     },
  //     headerCallback: function (thead, data, start, end, display) {

  //       $('th:first-child input', thead).unbind('click');
  //       $('th:first-child input', thead).bind('click', () => {

  //         var table5 = new $.fn.dataTable.Api('#table5');

  //         var count = table5.rows({ selected: true }).count();
  //         let selected = true;

  //         if (count > 0) {
  //           table5.rows().deselect();
  //           selected = false;
  //         }
  //         else
  //         table5.rows().select();

  //         $('th:first-child input', thead).prop("checked", selected);

  //       });
  //     },
  //     initComplete: () => {

  //       var self = this;
  //       var table5 = new $.fn.dataTable.Api('#table5');

  //       table5
  //         .on('select deselect', function (e, dt, type, indexes) {

  //           var table5 = new $.fn.dataTable.Api('#table5');
  //           var selected = table5.rows({ selected: true }).indexes().toArray();

  //           if (selected.length === 0)
  //             self.deleteOption = false;
  //           else
  //             self.deleteOption = true;
  //         });

  //       var buttons1 = new $.fn.dataTable.Buttons(table5, {
  //         dom: {
  //           button: {
  //             className: ''
  //           }
  //         },
  //         buttons: [
  //           {
  //             extend: 'csv',
  //             text: 'Export CSV',
  //             className: 'btn btn-info',
  //             exportOptions: {
  //               columns: '.selected',
  //               rows: function (idx, data, node) {
  //                 var dt = new $.fn.dataTable.Api('#table5');
  //                 var selected = dt.rows({ selected: true }).indexes().toArray();
  //                 if (selected.length === 0 || $.inArray(idx, selected) !== -1)
  //                   return true;

  //                 return false;
  //               }
  //             },
  //             title: "KaizenCloud"
  //           },
  //           {
  //             extend: 'pdfHtml5',
  //             text: 'Export PDF',
  //             className: 'btn btn-info',
  //             orientation: 'landscape',
  //             pageSize: 'A3',
  //             exportOptions: {
  //               columns: '.selected',
  //               rows: function (idx, data, node) {
  //                 var dt = new $.fn.dataTable.Api('#table5');
  //                 var selected = dt.rows({ selected: true }).indexes().toArray();

  //                 if (selected.length === 0 || $.inArray(idx, selected) !== -1)
  //                   return true;


  //                 return false;
  //               }
  //             },
  //             title: "KaizenCloud"
  //           },
  //           {
  //             extend: 'excel',
  //             text: 'Export Excel',
  //             className: 'btn btn-info',
  //             exportOptions: {
  //               columns: '.selected',
  //               rows: function (idx, data, node) {
  //                 var dt = new $.fn.dataTable.Api('#table5');
  //                 var selected = dt.rows({ selected: true }).indexes().toArray();

  //                 if (selected.length === 0 || $.inArray(idx, selected) !== -1)
  //                   return true;

  //                 return false;
  //               }
  //             },
  //             title: "KaizenCloud"
  //           },
  //           {
  //             extend: 'print',
  //             text: 'Print',
  //             className: 'btn btn-info',
  //             exportOptions: {
  //               columns: '.selected',
  //               rows: function (idx, data, node) {
  //                 var dt = new $.fn.dataTable.Api('#table5');
  //                 var selected = dt.rows({ selected: true }).indexes().toArray();

  //                 if (selected.length === 0 || $.inArray(idx, selected) !== -1)
  //                   return true;

  //                 return false;
  //               }
  //             },
  //             title: "KaizenCloud"
  //           },
  //         ], select: true
  //       }).container().appendTo($('#datatableExportBtn5'));

  //     }
  //   }

  // }

  datatableConfig5(): void {

    this.datatableColumns5();

    this.datatableOptions5 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs5,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table5 = new $.fn.dataTable.Api('#table5');

          var count = table5.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table5.rows().deselect();
            selected = false;
          }
          else
          table5.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table5 = new $.fn.dataTable.Api('#table5');

        table5
          .on('select deselect', function (e, dt, type, indexes) {

            var table5 = new $.fn.dataTable.Api('#table5');
            var selected = table5.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table5, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.plang.exportCSV,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod_DEMO_Project_document_"  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'pdfHtml5',
              text: this.plang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCluod_DEMO_Project_document_"  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'excel',
              text: this.plang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod_DEMO_Project_document_"  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'print',
              text: this.plang.print,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod_DEMO_Project_document_"  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn5'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }

  onchk(i, j) {
    // console.log($('#'+i).hasClass('selected'));

    $('.dmulval').val('');
    if ($('#' + i).hasClass('selected') == false) {
      $('.odplus_del' + j).css('display', 'inline-block');
      $('.dmulval').val(i);
    }
    else {
      $('.odplus_del' + j).css('display', 'none');
      $('.dmulval').val('');
    }

  }


  datatableColumns1(): void {

    this.datatableColsDefs1 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols1 = [
      { id: 2, value: 'No.', isSelected: false },
      { id: 3, value: 'Course Code', isSelected: false },
      { id: 4, value: 'Catalog Code', isSelected: false },
      { id: 5, value: 'Course Title', isSelected: false },
      { id: 6, value: 'Course Category', isSelected: false },
      { id: 7, value: 'Duration (Hours)', isSelected: false },
      { id: 8, value: 'End Date', isSelected: false },
      { id: 9, value: 'Start Date', isSelected: false },
      { id: 10, value: 'Customer', isSelected: false },
      { id: 11, value: 'Status', isSelected: false },
      { id: 12, value: 'Course Evaluation', isSelected: false },
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }

  datatableColumns2(): void {
    this.datatableColsDefs2 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols2 = [
      { id: 2, value: 'No.', isSelected: false },
      { id: 3, value: this.emplang.name, isSelected: false },
      { id: 4, value: this.emplang.surname, isSelected: false },
      { id: 5, value: this.emplang.email, isSelected: false },
      { id: 6, value: this.emplang.phone, isSelected: false },
      { id: 7, value: this.emplang.dob, isSelected: false },
      { id: 8, value: this.emplang.pob, isSelected: false },
      { id: 9, value: this.emplang.fiscalCode, isSelected: false },
      { id: 10, value: this.emplang.qualification, isSelected: false },
      { id: 11, value: this.emplang.business, isSelected: false }
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }


  datatableColumns3(): void {
    // this.datatableColsDefs3 = [
    //   {
    //     targets: 0,
    //     visible: false,
    //     orderable: false,
    //     className: 'hidden'
    //   },
    //   {
    //     targets: 1,
    //     orderable: false,
    //     className: 'select-checkbox'
    //   },
    // ];

    this.datatableCols3 = [
      { id: 0, value: 'No.', isSelected: false },
      { id: 1, value: this.clang.code, isSelected: false },
      { id: 2, value: this.clang.typeofContract, isSelected: false },
      { id: 3, value: this.clang.meetingperYear, isSelected: false },
      { id: 4, value: this.clang.startingDate, isSelected: false },
      { id: 5, value: this.clang.contract, isSelected: false },
      { id: 6, value: this.clang.amount, isSelected: false },
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }

  datatableColumns4(): void {
    this.datatableColsDefs4 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols4 = [
      { id: 2, value: this.alang.courseCode, isSelected: false },
      { id: 3, value: this.alang.catCode, isSelected: false },
      { id: 4, value: this.alang.courseName, isSelected: false },
      { id: 5, value: this.alang.courseCategory, isSelected: false },
      { id: 6, value: this.alang.durationHours, isSelected: false },
      { id: 7, value: this.alang.startDate, isSelected: false },
      { id: 8, value: this.alang.endDate, isSelected: false },
      { id: 9, value: this.alang.teacher, isSelected: false },
      { id: 10, value: this.alang.status, isSelected: false }
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }

  datatableColumns5(): void {

  this.datatableColsDefs5 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
        className: 'hidden'
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols5 = [
      { id: 2, value: 'No.', isSelected: false },
      { id: 3, value: this.plang.projectCode, isSelected: false },
      { id: 4, value: this.plang.type, isSelected: false },
      { id: 5, value: this.plang.topic, isSelected: false },
      { id: 6, value: this.plang.description, isSelected: false },
      { id: 7, value: this.plang.date, isSelected: false },
      { id: 8, value: this.plang.addresser, isSelected: false },
      { id: 9, value: this.plang.addressee, isSelected: false },
      { id: 10, value: this.plang.attachments, isSelected: false },
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }

  // datatableColumns3(): void{
  //   this.datatableColsDefs4 = [
  //   {
  //   targets: 0,
  //   visible: false,
  //   orderable: false,
  //   },
  //   {
  //   targets: 1,
  //   orderable: false,
  //   className: 'select-checkbox'
  //   },
  //   ];

  //   this.datatableCols3 = [
  //   { id: 2, value: 'No.', isSelected: false },
  //   { id: 3, value: 'Execution Date', isSelected: false },
  //   { id: 4, value: 'Description', isSelected: false },
  //   { id: 5, value: 'Performed By', isSelected: false },
  //   { id: 6, value: 'Outcome', isSelected: false },
  //   { id: 7, value: 'Note', isSelected: false },
  //   { id: 8, value: 'Option', isSelected: false },
  //   { id: 9, value: 'Upcoming Maintenance', isSelected: false },
  //   { id: 10, value: 'Reference Date', isSelected: false },
  //   { id: 11, value: 'Cost', isSelected: false },
  //   { id: 12, value: 'Attachments', isSelected: false }
  //   ];

  //   // this.datatableAddCols1 = [
  //   // { id: 2, value: 'Attachments', isSelected: false },
  //   // ];

  // }





  datatableFilter(): void {

    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      const filt1 = data[4] || '';
      const filt2 = data[10] || '';
      const filt3 = data[11] || '';
      const filt4 = data[14] || '';

      var status = true;

      //if (this.filter1 && filt1 != this.filter1)
      //status = false;

      let a = this.filter1;
      // console.log(a);
      Object.keys(a).forEach(function (key) {
        if (a[key].item_id && filt1 != a[key].item_id)
          status = false;
        return status;
      });



      let aa = this.filter2;
      Object.keys(aa).forEach(function (key) {
        if (aa[key].item_id && filt2 != aa[key].item_id)
          status = false;
        return status;
      });


      let aaa = this.filter3;
      Object.keys(aaa).forEach(function (key) {
        if (aaa[key].item_id && filt3 != aaa[key].item_id)
          status = false;
        return status;
      });


      let aaaa = this.filter4;
      Object.keys(aaaa).forEach(function (key) {
        if (aaaa[key].item_id && filt4 != aaaa[key].item_id)
          status = false;
        return status;
      });


      return status;

    });

  }

  datatableFilterAction(): void {
    // console.log(DataTables.Api);
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.draw();

      // dtInstance.columns().every(function () {});


    });
  }

  generalsFormInit(): void {


    this.generalsForm = this.formBuilder.group({
      code: ['', [Validators.required]],
      bussines_name: ['', [Validators.required]],
      address: ['', [Validators.required]],
      zip_code: ['', [Validators.required]],
      city: [''],
      province: [''],
      tax_code: ['', [Validators.required]],
      fiscal_code: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required]],
      website: ['', [Validators.required]],
      macro_sector: ['', [Validators.required]],
      attachments: [''],
      action: ['update'],
    });

  }
  FormBuildUpdate(): void {

    this.generalsForm.patchValue({
      code: this.single_data.code,
      bussines_name: this.single_data.bussines_name,
      address: this.single_data.address,
      zip_code: this.single_data.zip_code,
      city: this.single_data.city,
      province: this.single_data.province,
      tax_code: this.single_data.tax_code,
      fiscal_code: this.single_data.fiscal_code,
      phone: this.single_data.phone,
      email: this.single_data.email,
      website: this.single_data.website,
      macro_sector: this.single_data.macro_sector,
      attachments: this.single_data.attachments,
      // service_attach_exists: this.formBuilder.array([]),
      emp_id: this.single_data.emp_id,
      // service_recpon: this.single_data.service_recpon,
      id: this.single_data.serviceId
    });



  }



  tab5Actions() {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.projectService.generalList(this.id)
        .subscribe(
          (res) => {
            this.lang = this.projectService.viewLang(res);
            this.plang = this.projectService.viewLang(res);
            this.course = res.data.course;
            this.protocol = res.data.protocol;

            this.datatableConfig5();
            // this.datatableFilter();
          }
        );
    });
  }


  tab2Actions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      this.qualifiedTeacherService.generalList(this.id)
        .subscribe(
          (res) => {
            this.ollang = this.qualifiedTeacherService.viewLang(res);
            this.tab_details2 = res.data.tab_details2;
            // this.image_file = res.data.single_data.image_file1

            this.datatableConfig1();
            // this.datatableFilter();
          }
        );
    });

  }


  tab1Actions(): void {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.projectService.generalList(this.id)
        .subscribe(
          (res) => {
            this.lang = this.projectService.viewLang(res);
            this.plang = this.projectService.viewLang(res);
            this.course = res.data.course;
            this.protocol = res.data.protocol;

          }
        );
    });


  }


  tab3Actions(): void {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.projectService.generalList(this.id)
        .subscribe(
          (res) => {
            this.lang = this.projectService.viewLang(res);
            this.plang = this.projectService.viewLang(res);
            this.course = res.data.course;
            this.protocol = res.data.protocol;

          }
        );
    });


  }

  // tab4Actions(): void {

  //   this.route.params.subscribe(params => {
  //     this.id = params.id;

  //     // console.log(params);

  //     this.customersService.generalList(this.id)
  //       .subscribe(
  //         (res) => {
  //           this.clang = this.customersService.viewLang(res);
  //           this.constant_data = res.data.constant_info;
  //           // this.image_file = res.data.single_data.image_file1

  //           this.datatableConfig3();
  //           // this.datatableFilter();
  //         }
  //       );
  //   });



  // }

  // tab5Actions(): void {
  //   this.route.params.subscribe(params => {
  //     this.id = params.id;

  //     this.customersService.generalList(this.id)
  //       .subscribe(
  //         (res) => {
  //           this.alang = this.customersService.viewLang(res);
  //           this.scheduled_info = res.data.scheduled_info;
  //           // this.image_file = res.data.single_data.image_file1

  //           this.datatableConfig4();
  //           // this.datatableFilter();
  //         }
  //       );
  //   });


  // }

  // tab6Actions(): void {

  //   this.route.params.subscribe(params => {
  //     this.id = params.id;

  //     this.customersService.generalList(this.id)
  //       .subscribe(
  //         (res) => {
  //           this.plang = this.customersService.viewLang(res);
  //           this.get_project = res.data.get_project_info;
  //           // this.image_file = res.data.single_data.image_file1

  //           this.datatableConfig5();
  //           // this.datatableFilter();
  //         }
  //       );
  //   });


  // }

  error(msg: any) {
    this.generalService.notify_msg('error', msg);
  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.CUSTOMERS_VIEW + '/' + this.id]);
      });
  }

  success(msg: any) {

    //show success message
    this.generalService.notify_msg('success', msg);

    //redirect the current page
    // this.redirect();

    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.CUSTOMERS_VIEW + '/' + this.id]);
      });
    setTimeout(() => {
      window.location.reload();
    }, 3000);


  }


  mulitSelect() {
    this.dropdownList = [
      { item_id: this.lang.vehicle, item_text: this.lang.vehicle },
      { item_id: this.lang.plant, item_text: this.lang.plant },
      { item_id: this.lang.machine, item_text: this.lang.machine },
      { item_id: this.lang.fireDispenser, item_text: this.lang.fireDispenser },
      { item_id: this.lang.firstServiceDevice, item_text: this.lang.firstServiceDevice },
      { item_id: this.lang.individualProtectionDevice, item_text: this.lang.individualProtectionDevice },
      { item_id: this.lang.safetyEquipment, item_text: this.lang.safetyEquipment }
    ];


    let that = this;

    let loca = this.lang.locations;
    Object.keys(loca).forEach(function (key) {
      // console.log(loca[key]);   
      that.dropdownList1.push({ item_id: loca[key], item_text: loca[key] },)
    });


    let loca1 = this.lang.responsibles;
    Object.keys(loca1).forEach(function (key) {
      // console.log(loca1[key]);   
      that.dropdownList2.push({ item_id: loca1[key], item_text: loca1[key] },)
    });


    this.dropdownList3 = [
      { item_id: this.lang.active, item_text: this.lang.active },
      { item_id: this.lang.decommissioned, item_text: this.lang.decommissioned },
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings3 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };


  }


  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      this.datatableCols1[i].isSelected = selected;
    }
    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].id == id)
        this.datatableCols1[i].isSelected = selected;
    }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

  }



  export2_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      this.datatableCols2[i].isSelected = selected;
    }
    this.datatable_export2_choose_column();

  }

  export2_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].id == id)
        this.datatableCols2[i].isSelected = selected;
    }

    this.datatable_export2_choose_column();

  }

  datatable_export2_choose_column(): void {

    var table1_name = '#table2';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].isSelected)
        table1.column(parseInt(this.datatableCols2[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols2[i].id)).deselect();
    }

  }


  export3_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      this.datatableCols3[i].isSelected = selected;
    }
    this.datatable_export3_choose_column();

  }

  export3_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      if (this.datatableCols3[i].id == id)
        this.datatableCols3[i].isSelected = selected;
    }

    this.datatable_export3_choose_column();

  }

  datatable_export3_choose_column(): void {

    var table3_name = '#table3';
    var table3 = new $.fn.dataTable.Api(table3_name);

    for (var i = 0; i < this.datatableCols3.length; i++) {
      // if (this.datatableCols3[i].isSelected)
      table3.column(parseInt(this.datatableCols3[i].id)).select();
      // else
      // table3.column(parseInt(this.datatableCols3[i].id)).deselect();
    }

  }




  export4_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      this.datatableCols4[i].isSelected = selected;
    }
    this.datatable_export4_choose_column();

  }

  export4_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].id == id)
        this.datatableCols4[i].isSelected = selected;
    }

    this.datatable_export4_choose_column();

  }

  datatable_export4_choose_column(): void {

    var table1_name = '#table4';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].isSelected)
        table1.column(parseInt(this.datatableCols4[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols4[i].id)).deselect();
    }

  }


  export5_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols5.length; i++) {
      this.datatableCols5[i].isSelected = selected;
    }
    this.datatable_export5_choose_column();

  }

  export5_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols5.length; i++) {
      if (this.datatableCols5[i].id == id)
        this.datatableCols5[i].isSelected = selected;
    }

    this.datatable_export5_choose_column();

  }

  datatable_export5_choose_column(): void {

    var table5_name = '#table5';
    var table5 = new $.fn.dataTable.Api(table5_name);

    for (var i = 0; i < this.datatableCols5.length; i++) {
      if (this.datatableCols5[i].isSelected)
      table5.column(parseInt(this.datatableCols5[i].id)).select();
      else
      table5.column(parseInt(this.datatableCols5[i].id)).deselect();
    }

  }



  // addServicing() {

  //   this.addServicingModal = this.modalService.show(ServicingCreateComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });
  // }
  setPageView(view) {
    this.pageView = view;
  }

  // addExtra() {

  //   this.addExtraModel = this.modalService.show(ServicingExtraComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });
  // }




  // addMaintenance(SID, SPID, OID) {
  //   this.addMaintenanceModel = this.modalService.show(ServicingMaintenance, { class: 'modal-lgs', initialState: { 'SID': SID, 'SPID': SPID, 'OID': OID, 'action': 'modify', 'langs': this.lang } });
  // }

  // editServicing(ID) {
  //   this.addServicingModal = this.modalService.show(ServicingCreateComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.lang } });
  // }


  // viewServicing() {

  //   this.viewServicingModal = this.modalService.show(ServicingViewserviceComponent, { class: 'modal-lgs', initialState: { 'langs': this.lang } });

  // }



  delete(ID) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Are you sure to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  // delete_protocol(ID,PID) {

  //   this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure want to remove this?')
  //     .subscribe(
  //       (confirmed) => {

  //         if (!confirmed)
  //           return;

  //         this.projectService.delete_protocol(ID,PID)
  //           .subscribe(
  //             (res) => {
  //               if (res.status) {
  //                 this.generalService.notify_msg('success', res.msg);
              
  //                 this.router.navigateByUrl('/test', { skipLocationChange: true })
  //                   .then(() => {
  //                     this.router.navigate([AppFrontRoutes.PROJECT_VIEW+'/'+this.id]);
  //                   });
  //               }
  //               else {
  //                 this.generalService.notify_msg('error', res.msg);
  //               }
  //             });

  //       });
  // }

  delete_employee(ID) {

    this.confirmationDialogService.confirm('Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.customersService.delete_employee(ID)
            .subscribe(
              (res) => {
                if (res.status) {
                  this.generalService.notify_msg('success', res.msg);
              
                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.CUSTOMERS_VIEW+'/'+this.id]);
                    });
                }
                else {
                  this.generalService.notify_msg('error', res.msg);
                }
              });

        });
  }

  delete_ordinary(ID) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete_ordinary(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  delete_sdocuments(ID) {

    this.confirmationDialogService.confirm('Servicing Documents Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete_sdocuments(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  turnoff(sID, pid, rid) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Are you sure to deactivate?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.turnoff(sID, pid, rid)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
          $("#sactivate_plan").modal("hide");
        });
  }

  activate_plan(pid, sId) {

    $("#plan_id_forcd").val(pid);
    $("#pservice_id").val(sId);
    $("#sactivate_plan").modal("show");
  }

  multiDelete() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log('testtest'); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.customersService.multiOPLDelete(selectedRows)
            .subscribe(
              (res) => {
              
        if (res.status) {
          this.generalService.notify_msg('success', res.msg);

          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.CUSTOMERS_VIEW+'/'+this.id]);
            });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
        }
              });
        });
  }



  // multiDelete_protocol() {

  //   var table5 = new $.fn.dataTable.Api('#table5');
  //   let selectedRows = table5.rows({ selected: true }).ids().toArray();

  //   // console.log('testtest'); return false;

  //   this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
  //     .subscribe(
  //       (confirmed) => {

  //         if (!confirmed)
  //           return;

  //         this.projectService.multiDelete_protocol(selectedRows)
  //           .subscribe(
  //             (res) => {
              
  //       if (res.status) {
  //         this.generalService.notify_msg('success', res.msg);

  //         this.router.navigateByUrl('/test', { skipLocationChange: true })
  //           .then(() => {
  //             this.router.navigate([AppFrontRoutes.PROJECT_VIEW+'/'+this.id]);
  //           });
  //       }
  //       else {
  //         this.generalService.notify_msg('error', res.msg);
  //       }
  //             });
  //       });
  // }



  multiDelete1() {

    var table1 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.servicingService.delete_mextraordinary(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }


  doc_multiDelete() {

    var table4 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table4.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.servicingService.delete_msdocuments(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }


  deleteMultiOrdinary() {
    // console.log('sss1');
    var vcnt = $('th:first-child input').val();
    var oid = $('#dmulval').val();

    if (oid != "") {
      // console.log(oid);
      this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
        .subscribe(
          (confirmed) => {

            if (!confirmed)
              return;

            this.servicingService.deleteMultiOrdinary(oid)
              .subscribe(
                (res) => {
                  if (res.status)
                    this.success(res.msg);
                  else
                    this.error(res.msg);
                });
          });


    }
    else {
      for (let i = 1; i <= vcnt; i++) {
        // console.log(i);
        if ($('.chk' + i).is(":checked")) {
          var table3 = new $.fn.dataTable.Api('.otable' + i);
          // var table3 = new $.fn.dataTable.Api('.otable3');
          let selectedRows = table3.rows({ selected: true }).ids().toArray();

          this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
            .subscribe(
              (confirmed) => {

                if (!confirmed)
                  return;

                this.servicingService.deleteMultiOrdinary(selectedRows)
                  .subscribe(
                    (res) => {
                      if (res.status)
                        this.success(res.msg);
                      else
                        this.error(res.msg);
                    });
              });
        }
      }
    }

  }


  multiDuplicate() {

    var table2 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table2.rows({ selected: true }).ids().toArray();


    this.customersService.multiOLDuplicate(selectedRows)
      .subscribe(
        (res) => {
          if (res.status) {
            this.generalService.notify_msg('success', res.msg);
        
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.CUSTOMERS_VIEW+'/'+this.id]);
              });
          }
          else {
            this.generalService.notify_msg('error', res.msg);
          }
        });

  }


  multiDuplicateEmp() {

    var table2 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table2.rows({ selected: true }).ids().toArray();


    this.customersService.multiDuplicateEmp(selectedRows)
      .subscribe(
        (res) => {
          if (res.status) {
            this.generalService.notify_msg('success', res.msg);
        
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.CUSTOMERS_VIEW+'/'+this.id]);
              });
          }
          else {
            this.generalService.notify_msg('error', res.msg);
          }
        
        });

  }

  multiOrdDuplicate() {

    let vcnt = $('th:first-child input').val();
    for (let i = 1; i <= vcnt; i++) {
      if ($('.chk' + i).is(":checked")) {
        var table3 = new $.fn.dataTable.Api('.otable' + i);
        let selectedRows = table3.rows({ selected: true }).ids().toArray();

        this.servicingService.multiOrdDuplicate(selectedRows)
          .subscribe(
            (res) => {
              if (res.status)
                this.success(res.msg);
              else
                this.error(res.msg);
            });
      }
    }

  }

  doc_multiDuplicate() {

    var table3 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table3.rows({ selected: true }).ids().toArray();


    this.servicingService.doc_multiDuplicate(selectedRows)
      .subscribe(
        (res) => {
          if (res.status)
            this.success(res.msg);
          else
            this.error(res.msg);
        });

  }

  duplicate(ID) {

    this.confirmationDialogService.confirm('Duplicate Confirmation', 'Are you sure you duplicate this line?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.duplicate(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });


  }




  onPhotoPickerChange(ev) {
    let file = ev.target.files[0];
    file = ev.target.files[0];

    // console.log(file.name);
    let file_name = file.name;
    if (!(/\.(csv)$/i).test(file_name)) {
      alert('Please upload valid excel file_name .csv only.');
      $('#file').val('');
    }
    else {
      let fs = new FileReader();
      fs.onload = (res: any) => {
        this.getPhotoBase64 = res.target.result;
        $('#profile_input').val('');
      };
      fs.readAsDataURL(file);
    }
  }

  onclick(id) {
    // console.log(id);
    let profileImage = this.getPhotoBase64 ? this.getPhotoBase64.split(',').pop() : this.getPhotoBase64;

    if (profileImage != undefined && $('#file').val() != '') {
      this.customersService.updateEmpImport(profileImage, id)
        .subscribe(
          (res) => {
            if (res.status) {
              this.success(res.msg);
              $("#datatableExport2").modal("hide");
              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.CUSTOMERS_VIEW + '/' + this.id]);
                });
              setTimeout(() => {
                window.location.reload();
              }, 3000);

            }
            else {
              this.error(res.msg);
              $("#datatableExport2").modal("hide");
              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.CUSTOMERS_VIEW + '/' + this.id]);
                });
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
          });
    }
  }


  onSubmit(data) {

    // console.log(data.date); return false;

    var plan_id_forcd = $("#plan_id_forcd").val();
    var pservice_id = $("#pservice_id").val();

    if (data.date != "") {
      this.servicingService.active_status(data.date, plan_id_forcd, pservice_id)
        .subscribe(
          (res) => {
            if (res.status) {
              this.success(res.msg);
              $("#sactivate_plan").modal("hide");
            }
            else {
              this.error(res.msg);
              $("#sactivate_plan").modal("hide");

            }
          });
    }
    else {
      alert('Please Enter Start Date!!!');
    }

  }

  change_col(val,cid) {

    this.confirmationDialogService.confirm('Payment Referene Confirmation', 'Are you sure to change this')
      .subscribe(
        (confirmed) => {
      this.customersService.payment_reference(val,cid)
        .subscribe(
          (res) => {
            if (res.status) {
              this.success(res.msg);
              $("#sactivate_plan").modal("hide");
            }
            else {
              this.error(res.msg);
              $("#sactivate_plan").modal("hide");

            }
          });

        });
 

  }

  public selectAttachm(event: any, index) {

    this.generalsForm.value.attachments[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.generalsForm.value.attachments[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }

  
  selectImage()
{
  let input = document.createElement('input');
  input.type = 'file';
  input.accept="image/*";
  input.click();
  }



  // On file Select
  // updateImage(event) {
  //   this.image = this.sanitizer.bypassSecurityTrustUrl(
  //     window.URL.createObjectURL(event.target.files[0])
  //   );
  //   const file = event.target.files[0];
  //   let reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = () => {
  //     this.file = { 'name': file.name, 'attachments': reader.result, 'cid': this.id };
  //   };
  // }

  // OnClick of button Upload
  onUpload() {
    this.customersService.uploadimg(this.file)
      .subscribe(
        (res) => {
          if (res.status) {
            this.success(res.msg);
            $("#sactivate_plan").modal("hide");
          }
          else {
            this.error(res.msg);
            $("#sactivate_plan").modal("hide");

          }
        });
  }

  onUpload1(data) {

    this.customersService.uploadimg(data)
      .subscribe(
        (res) => {
          if (res.status) {
            this.success(res.msg);
            $("#sactivate_plan").modal("hide");
          }
          else {
            this.error(res.msg);
            $("#sactivate_plan").modal("hide");

          }
        });
  }

  // add_extraordinary(SID) {
  //   this.extraordinayModal = this.modalService.show(ServicingExtraOrdinaryComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.exodlang } });
  // }

  // edit_extraordinary(ID) {
  //   this.extraordinayModal = this.modalService.show(ServicingExtraOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.exodlang } });
  // }


  add_protocol() {
    // console.log(PID);
    this.protocolModal = this.modalService.show(ProtocolCreateComponent, { class: 'modal-lgs', initialState: { 'pid':this.id,'pcode':this.course.code, 'langs': this.plang } });
  }


  editProtocol(ID,PID) {
    // console.log(PID);
    this.protocolModal = this.modalService.show(ProtocolCreateComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'pid':this.id,'pcode':this.course.code, 'langs': this.plang } });
  }

  viewProtocol(ID,PID) {
    // console.log(PID);
    this.protocolModal = this.modalService.show(ProtocolViewComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'pid':this.id,'pcode':this.course.code, 'langs': this.plang } });
  }


  // edit_ordinary(ID, SID, PID) {
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'PID': PID, 'langs': this.odlang, 'action': "edit" } });
  // }


  // duplicate_ordinary(ID, SID, PID) {
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'PID': PID, 'langs': this.odlang, 'action': "duplicate" } });
  // }


  // add_sdocuments(SID) {
  //   console.log(SID);
  //   this.ordinayModal = this.modalService.show(ServicingDocumentsComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.doclang } });
  // }


  // edit_sdocuments(ID, SID) {
  //   this.ordinayModal = this.modalService.show(ServicingDocumentsComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'langs': this.doclang, 'action': 'edit' } });
  // }


  // add_operating(SID) {
  //   // console.log(PID);
  //   this.operatingModal = this.modalService.show(CustomersOperatingComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.ollang } });
  // }

  // edit_operating(OID, SID) {
  //   // console.log(PID);
  //   this.operatingModal = this.modalService.show(CustomersOperatingComponent, { class: 'modal-lgs', initialState: { 'OID': OID, 'SID': SID, 'langs': this.ollang } });
  // }
  // add_employee(SID) {
  //   // console.log(PID);
  //   this.employeeModal = this.modalService.show(CustomersEmployeeComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.ollang } });
  // }

  // edit_employee(OID, SID) {
  //   // console.log(PID);
  //   this.employeeModal = this.modalService.show(CustomersEmployeeComponent, { class: 'modal-lgs', initialState: { 'OID': OID, 'SID': SID, 'langs': this.ollang } });
  // }


}
